import axios from 'axios';
import Swal from 'sweetalert2';
import router from '@/router';

export function setup_logout_interceptors() {
axios.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    const response = error.response;

    if (
      response &&
      response.status === 401 &&
      response.data?.detail === "User inactive or deleted."
    ) 
    Swal.fire({
    icon: 'error',
    title: 'Account Deactivated',
    text: 'You’ve been logged out because your account is inactive or deleted.',
    confirmButtonText: 'OK',
    allowOutsideClick: false,
    allowEscapeKey: false,
    }).then(() => {
    sessionStorage.clear();
    localStorage.clear();
    router.push({ name: 'UserLogin' });
    });
    

    return Promise.reject(error);
  }
);
}